import "../components/Footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div>
            <h3 className="footer-heading">Natoshine</h3>
            <p className="footer-text">Leading pharmaceutical innovation for global healthcare excellence.</p>
          </div>
          <div>
            <h4 className="footer-subheading">Products</h4>
            <ul className="footer-list">
              <li>
                <a href="#products" className="footer-link">
                  Our Products
                </a>
              </li>
              <li>
                <a href="#innovation" className="footer-link">
                  Innovation
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="footer-subheading">Company</h4>
            <ul className="footer-list">
              <li>
                <a href="/about" className="footer-link">
                  About Us
                </a>
              </li>
              <li>
                <a href="/contact" className="footer-link">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="footer-subheading">Legal</h4>
            <ul className="footer-list">
              <li>
                <a href="#" className="footer-link">
                  Privacy
                </a>
              </li>
              <li>
                <a href="#" className="footer-link">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-copyright">
          <p>&copy; {currentYear} Natoshine Pharmaceuticals. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

